import { Injectable } from "@angular/core";
import { DwColumnFormatType, DwColumnRendererParams, DwDecoratorType, DwGridColumn, DwGridColumnDef, DwGridColumnRendererBase, getDefaultColumnStyle } from "@devwareapps/devware-cap";
import { CodeValuePermitType, PermitEntity, PermitRequestEntity, PermitsMetaDataItemNames } from "../meta-data/permits-meta-data.service";
import { PermitRequestService } from '../services/permit-request.service';
//import { _ } from 'lodash';

@DwGridColumn({
    keyName: 'permit-permit-type-column',
    display: 'Permit - Permit Types',
    decoratorType: DwDecoratorType.service,
    isGlobal: false,
    parentItemName:  PermitsMetaDataItemNames.Permit,
    allowAttr: false,
    requireAttr: false,
    allowAction: true,
    order: 1,
    columnStyleFunc: getDefaultColumnStyle,
})
@Injectable()
export class PermitPermitTypeColumnService implements DwGridColumnRendererBase {
   
    renderColumn(columnConfig: DwGridColumnDef<any>): (params: DwColumnRendererParams) => any {
        return (params) => {
            const data: PermitEntity = params.data;
            if (!data) return "";

            const types = data.PermitPermitType?.map(pt => pt.PermitTypeCvDisplay) || [];

            return types.join(", ");
        }
    }
}